<template>
  <div class="custom-select">
    <div class="custom-select-header" @click="toggleDropdown">
      <span>{{ selectedOption || "Select an option" }}</span>
      <span class="triangle" :class="{ rotate: dropdownVisible }"></span>
    </div>
    <div v-if="dropdownVisible" class="custom-select-dropdown" ref="dropdown">
      <div
        v-for="(option, index) in parsedOptions"
        :key="index"
        class="custom-option"
        @click="selectOption(option)"
        :class="{ selected: option === selectedOption }"
      >
        {{ option }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: [Array, String],
      required: true,
    },
  },
  data() {
    return {
      selectedOption: null,
      dropdownVisible: false,
    };
  },
  computed: {
    parsedOptions() {
      return typeof this.options === 'string' ? this.options.split(',') : this.options;
    },
  },
  methods: {
    toggleDropdown() {
      this.dropdownVisible = !this.dropdownVisible;

      if (this.dropdownVisible) {
        this.$nextTick(() => {
          this.scrollToSelectedOption();
        });
      }
    },
    selectOption(option) {
      this.selectedOption = option;
      this.dropdownVisible = false;
      this.$emit("input", option);
    },
    scrollToSelectedOption() {
      this.$nextTick(() => {
        const dropdown = this.$refs.dropdown;
        const selectedOptionElement = dropdown?.querySelector('.custom-option.selected');

        if (selectedOptionElement) {
          const dropdownHeight = dropdown.clientHeight;
          const optionTop = selectedOptionElement.offsetTop;
          const optionHeight = selectedOptionElement.clientHeight;

          dropdown.scrollTop =
            optionTop - dropdownHeight / 2 + optionHeight / 2;
        }
      });
    },
  },
};
</script>

<style scoped>
.custom-select {
  position: relative;
  display: inline-block;
  width: 100%;
  cursor: pointer;
  -webkit-user-select: none;
  z-index: 1;
}

.custom-select-header:hover {
  border: 1px solid #0f2e50;
}

.custom-select-header:focus {
  border: 1px solid black;
}

.custom-select-header {
  padding: 10px;
  border: 1px solid white;
  color: #333;
  font-size: 1.2em;
  font-family: "Poppins", sans-serif;
  background-color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.triangle {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid gray;
  transition: transform 0.3s ease;
}

.triangle.rotate {
  transform: rotate(180deg);
}

.custom-select-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  border-top: 1px solid #ccc;
  background-color: white;
  max-height: 250px;
  overflow-y: auto;
}

::-webkit-scrollbar {
  width: 12px;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
}

::-webkit-scrollbar-thumb {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  background: linear-gradient(to bottom, #3c6399 0%, #0f2e50 100%);
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
}
::-webkit-scrollbar-thumb:window-inactive {
  background: linear-gradient(to bottom, #3c6399 0%, #0f2e50 100%);
}

.custom-option {
  padding: 10px 0 10px 10px;
  cursor: pointer;
  font-size: 1.1em;
  color: #333;
  font-family: "Poppins", sans-serif;
}

.custom-option:hover {
  background-color: #0000000a;
}

.selected {
  background-color: rgb(200 200 200 / 53%);
}
</style>
